export const productArea = {
	titles: {
		productArea: "Área del producto",
		editProduct: "Editar producto",
		addInput: "Agregar insumo",
		editTechnicalSheet: "Editar ficha técnica",
	},
	tabs: {
		productDetail: "Detalles del producto",
		technicalSheet: "Ficha técnica",
	},
};
